var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 438.016 438.016",
    style: {
      enableBackground: "new 0 0 438.016 438.016"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B3B3B3"
    },
    cx: 219.003,
    cy: 380.166,
    r: 57.85
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M220.13,419.134h-2.254c-22.091,0-40-17.909-40-40v-27.859h82.254v27.859 C260.13,401.225,242.221,419.134,220.13,419.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCE7A7"
    },
    d: "M360.382,182.099v47.831c0,23.874-5.912,46.381-16.379,66.111 c-8.596,16.245-20.276,30.598-34.248,42.309c-24.553,20.574-56.2,32.963-90.746,32.963c-32.398,0-62.256-10.898-86.099-29.231 c-16.039-12.338-29.365-28.028-38.906-46.042c-10.446-19.731-16.379-42.237-16.379-66.111v-47.831 c0-3.959,0.175-7.865,0.483-11.731c2.673-32.429,16.266-61.752,37.127-84.279c14.456-15.638,32.418-27.997,52.632-35.842 c14.384-5.593,29.91-8.883,46.134-9.449c1.666-0.051,3.342-0.082,5.007-0.082c1.676,0,3.342,0.031,5.017,0.082 c16.214,0.566,31.719,3.866,46.093,9.439l0.031,0.01c18.466,7.177,35.061,18.116,48.828,31.873 c1.306,1.306,2.581,2.632,3.825,3.989c20.841,22.517,34.444,51.851,37.107,84.259C360.217,174.234,360.382,178.141,360.382,182.099 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5CF98"
    },
    d: "M309.754,330.711v7.639c-24.553,20.574-56.2,32.963-90.746,32.963 c-32.398,0-62.256-10.898-86.099-29.231v-11.372H309.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5CF98"
    },
    d: "M360.382,198.917v33.652l-141.374-58.565L77.624,232.579v-33.662c0-3.959,0.175-7.865,0.483-11.731 c2.673-32.429,16.266-61.752,37.127-84.279l52.632-35.842l51.141-34.824l51.11,34.814l0.031,0.01l52.653,35.863 c20.841,22.517,34.444,51.851,37.107,84.259C360.217,191.051,360.382,194.958,360.382,198.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M361.461,151.83v226.177H234.945v-78.933h39.07c0-19.443,15.752-35.194,35.194-35.194h33.724 v-92.638H95.083v92.638h33.724c9.716,0,18.517,3.938,24.882,10.302c6.375,6.375,10.313,15.176,10.313,24.892h39.07v78.933H76.555 V151.83c0-15.412,2.447-30.249,6.981-44.15c18.579-57.063,72.208-98.304,135.472-98.304c63.263,0,116.893,41.24,135.472,98.304 C359.014,121.581,361.461,136.418,361.461,151.83z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#999999"
    },
    points: "122.627,263.88 122.627,378.007 76.555,378.007 76.555,171.345 95.083,171.345  95.083,263.88  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M361.461,178.542v199.465H234.945v-78.933h39.07c0-19.443,15.752-35.194,35.194-35.194h33.724 v-85.338H361.461z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B3B3B3"
    },
    points: "315.389,263.88 315.389,378.007 361.461,378.007 361.461,171.345 342.933,171.345  342.933,263.88  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.395,251.796c-15.702,0-28.478-12.776-28.478-28.478s12.776-28.478,28.478-28.478 s28.478,12.776,28.478,28.478S165.097,251.796,149.395,251.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.62,251.796c-15.702,0-28.478-12.776-28.478-28.478s12.776-28.478,28.478-28.478 c15.702,0,28.478,12.776,28.478,28.478S304.323,251.796,288.62,251.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5FB7CE"
    },
    d: "M159.141,223.319c-5.383,0-9.746-4.363-9.746-9.746c0-3.363,1.704-6.329,4.295-8.08 c-1.38-0.332-2.814-0.526-4.295-0.526c-10.136,0-18.352,8.217-18.352,18.352c0,10.136,8.217,18.352,18.352,18.352 c10.136,0,18.352-8.217,18.352-18.352c0-1.482-0.195-2.915-0.526-4.296C165.469,221.615,162.504,223.319,159.141,223.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5FB7CE"
    },
    d: "M298.366,223.319c-5.383,0-9.746-4.363-9.746-9.746c0-3.363,1.704-6.329,4.295-8.08 c-1.38-0.332-2.814-0.526-4.295-0.526c-10.136,0-18.352,8.217-18.352,18.352c0,10.136,8.217,18.352,18.352,18.352 c10.136,0,18.352-8.217,18.352-18.352c0-1.482-0.195-2.915-0.526-4.296C304.695,221.615,301.73,223.319,298.366,223.319z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EA535E",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M195.515,271.739 c3.182,9.937,12.503,17.143,23.487,17.143c10.984,0,20.305-7.206,23.487-17.143"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5CF98"
    },
    points: "199.704,246.102 219.006,228.618 238.308,246.102  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M361.461,151.83v53.539l-18.528-7.68v-26.447h-89.996l-33.93-14.055l-33.93,14.055H95.083v26.447 l-18.528,7.68V151.83c0-15.412,2.447-30.249,6.981-44.15l135.472-92.258L354.48,107.68 C359.014,121.581,361.461,136.418,361.461,151.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M368.463,113.87v89.811l-149.455-61.916L69.553,203.68V113.87c0-7.567,3.743-14.641,9.994-18.898 L219.008,0l139.461,94.972C364.72,99.229,368.463,106.302,368.463,113.87z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4D4D4D"
    },
    points: "89.088,112.112 104.213,101.809 104.213,168.178 89.088,174.439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4D4D4D"
    },
    points: "117.887,92.505 158.387,64.919 158.387,145.733 117.887,162.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4D4D4D"
    },
    points: "172.062,55.603 212.171,28.295 212.171,123.452 172.062,140.068  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M368.463,113.87v89.811l-149.455-61.916V0l139.461,94.972 C364.72,99.229,368.463,106.302,368.463,113.87z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "225.845,28.295 265.944,55.603 265.944,140.068 225.845,123.452  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "279.619,64.908 320.129,92.505 320.129,162.512 279.619,145.733  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "348.928,112.112 348.928,174.439 333.803,168.178 333.803,101.809  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.083,
    y: 207.33,
    style: {
      fill: "#E5CF98"
    },
    width: 19.319,
    height: 56.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.614,
    y: 207.33,
    style: {
      fill: "#E5CF98"
    },
    width: 19.319,
    height: 56.549
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnight);
export default __webpack_public_path__ + "static/media/knight.48a04a63.svg";
export { ForwardRef as ReactComponent };